export const pages = ['About', 'Blog', 'Contact'];
export const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];